import { cn, getStatusLabel } from '@/lib/utils';

const statusStyles = {
  working: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30 shadow-[0_0_10px_rgba(16,185,129,0.2)]',
  pause: 'bg-amber-500/20 text-amber-400 border-amber-500/30 shadow-[0_0_10px_rgba(245,158,11,0.2)]',
  lunch: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30 shadow-[0_0_10px_rgba(14,165,233,0.2)]',
  outside: 'bg-slate-500/20 text-slate-400 border-slate-500/30',
  no_gps: 'bg-rose-500/20 text-rose-400 border-rose-500/30 shadow-[0_0_10px_rgba(225,29,72,0.2)]',
};

export default function StatusBadge({ status, className }) {
  return (
    <span 
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold uppercase tracking-wide",
        statusStyles[status] || statusStyles.outside,
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      <span className={cn(
        "w-1.5 h-1.5 rounded-full",
        status === 'working' && 'bg-emerald-400 animate-pulse',
        status === 'pause' && 'bg-amber-400',
        status === 'lunch' && 'bg-cyan-400',
        status === 'outside' && 'bg-slate-400',
        status === 'no_gps' && 'bg-rose-400 animate-pulse'
      )} />
      {getStatusLabel(status)}
    </span>
  );
}
